// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__2gmpE","spinner":"spinner_spinner__3v0om","smallSpinner":"spinner_smallSpinner__Daqh1"};